import { render, staticRenderFns } from "./DefaultPositionButton.vue?vue&type=template&id=39ea15d6&scoped=true&"
import script from "./DefaultPositionButton.vue?vue&type=script&lang=js&"
export * from "./DefaultPositionButton.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPositionButton.vue?vue&type=style&index=0&id=39ea15d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea15d6",
  null
  
)

export default component.exports